const dataInicial = {
    load: false,
    message: ""
};

const ON_LOAD_ACTION = "ON_LOAD_ACTION";
const OFF_LOAD_ACTION = "ON_LOAD_ACTION";

export default function loadReducer(state = dataInicial, action) {
    switch (action.type) {
        case ON_LOAD_ACTION:
            return { ...state, load: action.payload.load, message: action.payload.message }
        case OFF_LOAD_ACTION:
            return { ...state, load: action.payload.load, message: action.payload.message }
        default:
            return state;
    }
}
export const onLoadAnction = ({message = "" }) => async (dispatch) => {
    dispatch({
        type: ON_LOAD_ACTION,
        payload: {
            load: true,
            message,
        },
    })
}
export const offLoadAction = () => async (dispatch) => {
    dispatch({
        type: OFF_LOAD_ACTION,
        payload: {
            load: dataInicial.load,
            message: dataInicial.message,
        },
    })
}
